import React, { useState, useEffect, useRef } from 'react';
import App from './App';
//import './appThemeDark.css';
import './appThemeLight.css';
//import './appThemeFunnel.css';
import { addSocketListener, removeSocketListener, getSocket } from './sockets';
import * as amplitude from '@amplitude/analytics-browser';
import {plugin as amplitudeEngagementPlugin} from '@amplitude/engagement-browser';
import { createBrowserHistory } from 'history';
import { fetchWithDefaults } from './config/fetchDefault';
import ActionAlert from './actionAlert';
import { useDispatch } from 'react-redux';
import { setMissedCall } from './features/missedCallSlice';
import { setUnheard, addVoicemail } from './features/voicemailSlice';
import { setUserData } from './features/agentSlice';
import Signup from './template/signup/signup';
import { gatherTheme, applyTheme, SSO, decrypt } from './utilities/appSetup';
import AdPreview from './adPreview';
import MigrationLandingPage from './template/migrationLandingPage/main';
import SignupPreUpdates from './template/signup/signupPreUpdate';
import { setConversations, updateUnreadMessages } from './features/conversationSlice';
import { useSelector } from 'react-redux';
import { useAuth0 } from '@auth0/auth0-react';
import { fetchOverwrite, restoreFetch } from './utilities/auth0Functions';
import { setBackup, setQueue, setQueueSort, setWholeQueue } from './features/queueSlice';
import LoadingAuth0Redirect from './LoadingAuth0Redirect';
import { ServerErrorModal } from './template/conversations/tMobileError';
import { AgentContext } from './context/AgentContext';
import {
	initializeExperiment,
	setExperimentUser,
} from "./template/amplitude";

const history = createBrowserHistory();

const { io } = require("socket.io-client");
amplitude.init(process.env.REACT_APP_FUNNEL_AMPLITUDE);
amplitude.add(amplitudeEngagementPlugin());
initializeExperiment();
/**
 * @typedef {object} ExperimentBannerProps
 * @property {string | null | undefined} title
 * @property {string} message
 * @property {boolean} isVisible
 */
function Init() {
    const { isLoading, isAuthenticated, error, user, getAccessTokenSilently, logout } = useAuth0()
    const isFeature156Enabled = process.env.REACT_APP_FUNNEL_FEATURE_156 === 'true'
    const dispatch = useDispatch();
    const [migrateAgent, setMigrateAgent] = useState(false);
    const [signedIn, setSignedIn] = useState(false);
    const [agentIdNumber, setAgentIdNumber] = useState(null);
    const [newMessages, setNewMessages] = useState([]);
    const currentURL = window.location.pathname;
    const currentQuery = window.location.search;
    const currentSearch = currentQuery.split("code=")[1];
    const [unreadMessages, setUnreadMessages] = useState(false);
    const [showServerError, setShowServerError] = useState(false);
    const agentUnreadMessages = useSelector(state => state.conversations.unreadMessages)
    const agentUser = useSelector(state => state.agent.userData);
    const [agentOrganization, setAgentOrganization] = useState('master');
    const [ stylePath, setStylePath ] = useState("/appThemeDark.css");

    const saveData = async (cipher) => {
        localStorage.setItem('keepMeAlive', cipher);
    };

    const saveSSO = async (cipher) => {
        localStorage.setItem('keepMeAlive', cipher);
		window.location.href = '/'
    };

	useEffect(
		() => {
			if (agentIdNumber) {
				setExperimentUser(agentIdNumber);
			}
		},
		[agentIdNumber]
	);

	useEffect(
		() => {
			if (!signedIn) {
				return;
			}
			const {
				firstName,
				lastName,
				email,
			} = agentUser || {};
			try {
				const idObj = new amplitude.Identify();
				if (agentIdNumber) {
					idObj.set(
						"agent_id",
						agentIdNumber,
					);
				}
				if (firstName || lastName) {
					idObj.set(
						"name",
						`${firstName ?? ""} ${lastName ?? ""}`.trim(),
					);
				}
				if (email) {
					idObj.set(
						"email",
						email,
					);
				}
				amplitude.identify(idObj);
				amplitude.logEvent("User Logged In");
			} catch (err) {
				console.error(
					"Amplitude identify/track failed: %s",
					err,
					err,
				);
			}
		},
		[
			signedIn,
			agentIdNumber,
		],
	);

    useEffect(() => {
        document.title = "Funnel";

        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = `${process.env.REACT_APP_FUNNEL_BUGHERD}`;
        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, []);


  useEffect(() => {
    const handleServerError = () => setShowServerError(true);
    window.addEventListener("serverError", handleServerError);
    return () => window.removeEventListener("serverError", handleServerError);
  }, []);

    const signOut = async () => {
        try {
            const requestOptions = {
                method: 'POST',
                body: JSON.stringify({
                    agent: agentIdNumber,
                    source: 'web'
                })
            };
            const response = await fetchWithDefaults('/login/logout', requestOptions);
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            localStorage.removeItem('keepMeAlive');
            setSignedIn(false)
            await logout({ logoutParams: { returnTo: window.location.origin } })
            restoreFetch()
        } catch (error) {
            console.log('Unable to Logout', error)
        }
    };
    const handleSetUnread = (amount) => {
        setUnreadMessages(amount)
        dispatch(updateUnreadMessages(amount))
    }
    const runSSO = async () => {
        const cipher = await SSO(currentQuery);
        if (cipher.agentCode) {
            console.log(cipher)
            history.push(`/migrate/quility/activate`, { forced: true });
            setMigrateAgent(cipher.agentCode);
        }
        else if (cipher !== undefined) {
            await saveData(cipher[0]);
            await decrypt(cipher[0], applyTheme, gatherTheme, dispatch, setAgentIdNumber, setSignedIn, saveData);
            window.location.href = '/'
        }
    }

    const slugs = ["/lead", "/Call_Recording", "/Trust_Hub", "/Workflows", "/Activity", "/Overview", "/Market", "/dash", "/Integrations", "/Add_Leads", "/Follow_Ups", "/Scheduled_Calls", "/Scheduled_Appointments", "/Subscription", "/Number", "/Voicemail", "/VoiceDrop", "/Call_Forwarding", "/Tags", "/Lead_Types", "/Text_Templates", "/Email_Templates", "/Scripts", "/Objections", "/Team", "/Account"];

    useEffect(() => {
        //onsole.log('auth0', { isLoading, isAuthenticated, error, user })

        if (!process.env.REACT_APP_ENV || process.env.REACT_APP_ENV === 'production') {
            return
        }

        // Get required variables from environment-specific list
        const requiredVars = (process.env.REACT_APP_FUNNEL_REQUIRED || '').split(',').filter(Boolean);
        if (!requiredVars.length) {
            console.error('REACT_APP_FUNNEL_REQUIRED is not set or is empty');
            return;
        }
        let missingVars = 0;
        requiredVars.forEach((varName) => {
            if (!process.env[varName.trim()]) {
                console.error(`Missing environment variable: ${varName.trim()}`);
                missingVars++;
            }
        });
        if (missingVars > 0) {
            console.error(`${missingVars} required environment variables are missing`);
        }

        //console.info('Availble environment variables', Object.entries(process.env).filter(e => !e[0].includes('_AUTH0_')))
    }, [])

    const auth0Fetch = useRef(false)

    const agentAuth0Call = async () => {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({
            source: 'web'
            })
        }

        try {
            const res = await fetchWithDefaults('/login/loginUserAuth0', requestOptions)
            const jsonData = await res.json()

            //console.log('agentAut0Call',`agent id: ${jsonData[0].id}`, JSON.stringify(jsonData))

            const root = document.documentElement;
            console.log({root})
            const theme=await gatherTheme(jsonData[0].organization);
            await applyTheme(theme,root,dispatch);
            dispatch(setUserData({
                agentId: jsonData[0].id,
                organization: jsonData[0].organization,
                admin: jsonData[0].admin===1,
                organizationName:jsonData[0].orgName,
                permissions:jsonData[0].permissions,
                agentCode:jsonData[0].agentCode,
                beta:jsonData[0].beta===0 ? false : true,
                a2pOnly:jsonData[0].beta===2 ? true : false,
                status:jsonData[0].agentStatus==='inactive' ? false : true,
                tenantId: jsonData[0].tenant_id,
                navigator_sso: jsonData[0].navigator_sso,
                product_id: jsonData[0].product_id,
            }))

            setAgentIdNumber(jsonData[0].id);
            setAgentOrganization(jsonData[0].organization)

            // add b2b if organization is not master
            if(jsonData[0].organization !== 'master'){
                const appRootElm = document.getElementById('root')
                appRootElm.classList.add('b2b')
            }
        } catch (error) {
            console.error(error)
            await logout({ logoutParams: { returnTo: window.location.origin } })
        }
    }

    useEffect(() => {
        if (isAuthenticated === true && auth0Fetch.current === false) {
            fetchOverwrite(getAccessTokenSilently)
            auth0Fetch.current = true

            agentAuth0Call()
        }

        if(isAuthenticated === true && auth0Fetch.current === true){

            // moving over functionality that was previously being handled in login.js
            dispatch(setConversations([]));
            dispatch(setBackup([]))
            dispatch(setQueue([]))
            dispatch(setWholeQueue([]))
            dispatch(setQueueSort([]))

            // need pass a value into agentIdNumber after the agent has been authenticated.
            if (agentIdNumber) {
                const socket = getSocket();

                // Helper function to create unique message identifier for deduplication
                const getMessageId = (msg) => {
                    return `${msg.convo_id || ''}_${msg.time || ''}_${msg.message || ''}`;
                };
                const addMessageDeduplicated = (newMessage) => {
                    setNewMessages(prevMessages => {
                        const messageId = getMessageId(newMessage);
                        const exists = prevMessages.some(msg => getMessageId(msg) === messageId);
                        if (exists) {
                            return prevMessages;
                        }
                        return [newMessage, ...prevMessages];
                    });
                };
                const handleConnect = (message) => {
                    socket.emit('initialization', agentIdNumber);
                };

                const handleNewText = (arg) => {
                    addMessageDeduplicated(arg);
                    let newUnread;

                    if (!agentUnreadMessages) {
                        newUnread = 1;
                    }
                    else {
                        newUnread = parseInt((parseInt(agentUnreadMessages) + 1));
                    }
                    handleSetUnread(newUnread);
                };

                const handleUnread = (arg) => {
                    handleSetUnread(arg);
                };

                const handleSentText = (arg) => {
                    addMessageDeduplicated(arg);
                };

                const handleMissedCall = (arg) => {
                    dispatch(setMissedCall(arg));
                };

                const handleVoicemail = (arg) => {
                    dispatch(setUnheard(arg));
                    //dispatch(addVoicemail(arg.voicemail))
                };

                // Remove existing listeners before adding new ones to prevent duplicates
                socket.off('connect');
                socket.off("newText");
                socket.off("unread");
                socket.off("sentText");
                socket.off("missedCall");
                socket.off("voicemail");

                // Register listeners
                socket.on('connect', handleConnect);
                socket.on("newText", handleNewText);
                socket.on("unread", handleUnread);
                socket.on("sentText", handleSentText);
                socket.on("missedCall", handleMissedCall);
                socket.on("voicemail", handleVoicemail);

                // Cleanup function to remove listeners when effect re-runs or component unmounts
                return () => {
                    socket.off('connect', handleConnect);
                    socket.off("newText", handleNewText);
                    socket.off("unread", handleUnread);
                    socket.off("sentText", handleSentText);
                    socket.off("missedCall", handleMissedCall);
                    socket.off("voicemail", handleVoicemail);
                };
            }
        }
    }, [isAuthenticated, auth0Fetch, agentIdNumber])

    useEffect(()=>{ console.log('agentIdNumber', agentIdNumber)}, [agentIdNumber])
    const audience = process.env.REACT_APP_HQ_AUTH0_AUDIENCE
    return (
        <>
            <AgentContext.Provider value={{isB2B: agentOrganization !== 'master'}}>
            {
                isAuthenticated ? (
                !agentIdNumber ? (
                    <LoadingAuth0Redirect />
                ) : isAuthenticated && (currentURL && !slugs.includes(currentURL)) && currentURL !== '/dash' && currentURL !== '/signin' && currentURL !== '/auth' && currentURL !== '/quilityAuth' && currentURL !== '/ssoLogin' && currentURL !== '/authorization' && currentURL !== '/signup' ? (
                    <>
                        <ActionAlert newMessages={newMessages} />
                        <App auth={null} unreadMessages={unreadMessages} handleSetUnread={handleSetUnread} newMessages={newMessages} agentId={agentIdNumber} signOut={signOut} />
                    </>
                ) : slugs.includes(currentURL) ? (
                    <App currentQuery={currentQuery} load={currentURL ? currentURL.split('/')[1] : ''} unreadMessages={unreadMessages} handleSetUnread={handleSetUnread} newMessages={newMessages} agentId={agentIdNumber} signOut={signOut} />
                ) : currentURL === '/quilityAuth' ? (
                    window.location.href = `https:${process.env.REACT_APP_FUNNEL_AUTH_QUILITY}//authorize?response_type=code&client_id=${process.env.REACT_APP_AUTH0_CLIENT_ID}&redirect_uri=https://${window.location.hostname}/api/quility/authorize&scope=profile email offline_access read:Agents&${audience}=http://api.quility.com&state=init`
                ) : currentURL === '/ssoLogin' && currentSearch ? (
                    saveSSO(currentSearch)
                ) : currentURL === '/signup' && isFeature156Enabled === true ? (
                    <Signup />
                ) : currentURL === '/signup' && isFeature156Enabled === false ? (
                    <SignupPreUpdates />
                ) : currentURL === '/authorization' ? (
                    <>
                        <ActionAlert newMessages={newMessages} />
                        <App auth='gather' unreadMessages={unreadMessages} handleSetUnread={handleSetUnread} newMessages={newMessages} agentId={agentIdNumber} signOut={signOut} />
                    </>
                ) : currentURL === '/dash' ? (
                    <>
                        <ActionAlert newMessages={newMessages} />
                        <App auth={null} unreadMessages={unreadMessages} handleSetUnread={handleSetUnread} newMessages={newMessages} agentId={agentIdNumber} signOut={signOut} />
                    </>
                ) : currentURL === '/auth' ? (
                    <App auth='authenticate' unreadMessages={unreadMessages} handleSetUnread={handleSetUnread} newMessages={newMessages} agentId={agentIdNumber} signOut={signOut} />
                ) : (
                    <>
                        <ActionAlert newMessages={newMessages} />
                        <App auth={null} unreadMessages={unreadMessages} handleSetUnread={handleSetUnread} newMessages={newMessages} agentId={agentIdNumber} signOut={signOut} />
                    </>
                )
            ) : migrateAgent ? (
                <MigrationLandingPage agentCode={migrateAgent} />
            ) : currentURL === '/signup' && isFeature156Enabled === true ? (
                <Signup />
            ) : currentURL === '/signup' && isFeature156Enabled === false ? (
                <SignupPreUpdates />
            ) : currentURL === '/quilityAuth' ? (
                window.location.href = `${process.env.REACT_APP_FUNNEL_AUTH_QUILITY}/authorize?response_type=code&client_id=${process.env.REACT_APP_AUTH0_CLIENT_ID}&redirect_uri=https://${window.location.hostname}/api/quility/authorize&scope=profile email offline_access read:Agents&audience=${audience}&state=${currentQuery}` /// do we need to add back in "init" to the state=init${currentQuery} once we start onboarding agents?
            ) : currentURL === '/adPreview' ? (
                <AdPreview />
            ) : currentURL === '/api/quility/authorize' ? (
                runSSO(),
                null
            ) : (
                // this component serves as a default state for the app
                // this should just show the loading gif until
                // auth0 function withAuthenticationRequired triggers the redirect to the auth0 login.
                // will also help prevent any logic in the <App /> component from running before
                // the agent is fully authenticated
                <LoadingAuth0Redirect />

            )
            }
            </AgentContext.Provider>
        </>
    )
}

export default Init;